(function($){

    $.fn.carousel = function(){

        var elem = $(this),
            viewLimit = elem.data('view_limit');

        if(!viewLimit){

            viewLimit = 4;

        }

        const init = function(){

            elem.slick({
                //centerMode: true,
                //centerPadding: '50px',
                slidesToShow: viewLimit,
                slidesToScroll: viewLimit / 2,
                autoplay: true,
                infinite: true,
                arrows: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '150px',
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            centerPadding: '0px',
                            slidesToShow: 1
                        }
                    }
                ]

            });

        };

        init();

        return this;

    }

}(jQuery));